// components/TaxBracket.jsx
import React from "react";
import { Row, Col } from "reactstrap"; // adjust import to match your setup
 
const TaxBracket = ({ itemTaxPreference, itemTax, show = "both" }) => {

  if (itemTaxPreference === "exempt" || itemTaxPreference === "nil" || itemTax?.length === 0) {
    return null;
  }
  const resolveName = (specification) => {
    const pref = itemTax?.find(
      (p) => p.taxSpecification === specification
    );
    if (!pref) return null;

    const { taxId: { name, totalRate } } = pref;
    return `${name} [${totalRate}%]`;
  };

  const allBrackets = [
    { key: "intra", label: "Intra State Tax", name: resolveName("intra") },
    { key: "inter", label: "Inter State Tax", name: resolveName("inter") },
  ];

  const brackets =
    show === "both" ? allBrackets : allBrackets.filter((b) => b.key === show);

  return (
    <>
      {brackets.map((b) => (
        <Row key={b.key}>
          <Col xs="4">
            <p>{b.label}:</p>
          </Col>
          <Col xs="8">
            <p>{b.name || "-"}</p>
          </Col>
        </Row>
      ))}
    </>
  );
};

export default TaxBracket;